<template>
  <router-view>
  </router-view>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* 全局样式 */
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
